import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const TachographDriversHoursPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  complianceOfficerContact,
  trainingContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Tachograph_and_Drivers_Hours_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Tachograph & Drivers' Hours Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        To ensure compliance with tachograph regulations and drivers' hours rules, promoting road safety, driver welfare, and legal adherence.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all drivers and fleet managers involved in operating vehicles requiring tachographs.
      </p>

      <h4 className="section-title">3. Tachograph and Drivers' Hours Rules (Basic Overview)</h4>
      <ul>
        <li>Maximum daily driving time: 9 hours (can be extended to 10 hours twice a week).</li>
        <li>Maximum weekly driving time: 56 hours.</li>
        <li>Maximum fortnightly driving time: 90 hours.</li>
        <li>Minimum daily rest period: 11 hours (can be reduced to 9 hours up to three times between weekly rests).</li>
        <li>Weekly rest period: Minimum 45 consecutive hours.</li>
        <li>Drivers must record all activities accurately using digital or analogue tachographs.</li>
        <li>Regular downloading, analysis, and retention of tachograph data are mandatory.</li>
      </ul>

      <h4 className="section-title">4. Responsibilities</h4>
      <p className="section-content"><strong>Drivers:</strong> Must comply with all tachograph and drivers' hours rules and report any issues immediately.</p>
      <p className="policy-details"><strong>Compliance Officer:</strong> {complianceOfficerContact || "[Insert Contact]"}</p>
      <p className="policy-content"><strong>Training Department:</strong> Ensures all drivers are trained on tachograph use and regulations. Contact: {trainingContact || "[Insert Contact]"}</p>

      <h4 className="section-title">5. Monitoring and Enforcement</h4>
      <p className="section-content">
        Regular audits and checks of tachograph records will be conducted. Non-compliance may result in disciplinary action.
      </p>

      <h4 className="section-title">6. Record Keeping</h4>
      <p className="section-content">
        Tachograph records must be retained for a minimum of 12 months and made available to enforcement authorities upon request.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Tachograph and Drivers' Hours Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default TachographDriversHoursPolicy;
